function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.224.5321L15.0681.156 14.692 0h-4.2797a.5322.5322 0 0 0 0 1.0643h2.9947L8.1415 6.33a.5323.5323 0 0 0 0 .7525.5323.5323 0 0 0 .7525 0l5.2655-5.2654v2.995a.5322.5322 0 0 0 1.0643 0l.0002-4.28zm-1.419 9.5635v2.1127c-.002 1.6622-1.3535 3.0137-3.0158 3.0157H3.0157C1.3535 15.222.002 13.8705 0 12.2083V4.4348C.002 2.7725 1.3535 1.421 3.0157 1.419h2.1127a.5322.5322 0 0 1 0 1.0642H3.0157c-1.0696.002-1.9495.8818-1.9514 1.9515v7.7735c.002 1.0696.8818 1.9495 1.9514 1.9512h7.7735c1.0697-.002 1.9495-.8818 1.9515-1.9512v-2.1127a.5322.5322 0 0 1 1.0642 0z",
  fill: "#2C46A6",
  fillRule: "evenodd"
});

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/externalLink.12ebbde2.svg";
export { ForwardRef as ReactComponent };